// extracted by mini-css-extract-plugin
export var deleteModal = "_rt-0";